import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { BaseComponent, Shared } from '@rubii/frontend-common';

@Component({
  selector: 'app-base-datasource',
  templateUrl: './base-datasource.component.html',
  styleUrls: ['./base-datasource.component.scss']
})
export class BaseDatasourceComponent extends BaseComponent implements OnInit {

  dataSourcesDict = Shared.dicts.DataSources;

  clientId: FormControl;
  clientSecret: FormControl;
  partnerId: FormControl;
  partnerIds: FormControl;
  connectionForm: FormGroup;

  constructor() {
    super();
  }

  ngOnInit() { }

}
